import React from 'react';
import PropTypes from 'prop-types';
import setInnerHTML from 'utils/setInnerHTML';
import withStyles from 'isomorphic-style-loader/withStyles';

import styles from './pullquote.css';

const Pullquote = ({ title, text, source }) => (
  <div className={styles.wrapper}>
    <div>
      <h2>{title}</h2>
      <p
        dangerouslySetInnerHTML={setInnerHTML(text)} // eslint-disable-line react/no-danger
      />
      <cite>{source}</cite>
    </div>
  </div>
);

Pullquote.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  source: PropTypes.string,
};

Pullquote.defaultProps = {
  source: '',
  title: '',
};

export default withStyles(styles)(Pullquote);
